import { createGuid } from '@bimser/core';
import { Resizable } from 're-resizable';
import * as React from 'react';
import Styles from '../assets/deviceViewerStyles.scss';
import { EDeviceTypes, IDeviceContentProps } from '../entities';

const [minWidth, minHeight] = [250, 250];
const handleClasses = {
	right: Styles.right,
	bottom: Styles.bottom,
	left: Styles.left,
	bottomRight: Styles.bottomRight,
	bottomLeft: Styles.bottomLeft
};

export default (props: React.PropsWithChildren<IDeviceContentProps>) => {
	const resizeTooltipId = createGuid();
	const resizableRef = React.useRef<Resizable>();

	const enableResize = React.useMemo(
		() =>
			props.selectedDevice !== EDeviceTypes.Responsive
				? null
				: {
						top: false,
						right: true,
						bottom: true,
						left: true,
						topRight: false,
						bottomRight: true,
						bottomLeft: true,
						topLeft: false
				  },
		[props.selectedDevice]
	);

	const onResize = React.useCallback(
		(...[, , , delta]): void => {
			const width = Math.max(props.dimension.width + delta.width, minWidth);
			const height = Math.max(props.dimension.height + delta.height, minHeight);

			document.getElementById(resizeTooltipId).title = width + ' x ' + height;
		},
		[props.dimension]
	);

	const onResizeStop = React.useCallback(
		(...[, , , delta]): void => {
			document.getElementById(resizeTooltipId).title = '';

			props.onDimensionChanged({
				width: Math.max(props.dimension.width + delta.width, minWidth),
				height: Math.max(props.dimension.height + delta.height, minHeight)
			});
		},
		[props.dimension]
	);

	return (
		<div
			className={Styles.contentResizer}
			style={props.zoomStyle}
		>
			<Resizable
				ref={resizableRef}
				className={Styles.content}
				defaultSize={props.dimension}
				onResize={onResize}
				onResizeStop={onResizeStop}
				minWidth={minWidth}
				minHeight={minHeight}
				bounds="parent"
				enable={enableResize}
				handleWrapperClass={Styles.deviceViewerResizerHandlers}
				handleClasses={handleClasses}
			>
				{props.children}
				<div
					id={resizeTooltipId}
					className={Styles.resizeTooltip}
				/>
			</Resizable>
		</div>
	);
};
